import classNames from 'classnames';
import React, { FC } from 'react';

interface IButtonProps {
    iconName: string;
    onClick?: () => void;
    title?: string;
    isActive?: boolean;
    disabled?: boolean;
}

const Button: FC<IButtonProps> = (props) => {
    const { iconName, title, isActive, disabled } = props;
    return (
        <button
            disabled={disabled}
            title={title}
            className={classNames(
                "flex items-center justify-center p-3 rounded-full bg-gray-200",
                {
                    'bg-blue-100': isActive
                }
            )}
            onClick={props.onClick}
        >
            <span className={classNames(
                `bp3-icon bp3-icon-${iconName} text-lg`,
                {
                    "text-gray-400": disabled,
                    "text-gray-900": !disabled
                }
            )}
            />
        </button>
    );
};

export default Button;
